module.exports = __webpack_public_path__ + "media/images/smart_phone/icon_log-4424e2a13c797baa908ae92d11e9f5bf.png";